import { VariableContextType } from '../constants/bulk-message-variables';

export const BULK_MESSAGING_EVENTS = {
  SEND_BULK_MESSAGES: 'whatsapp/bulk-messages.send',
} as const;

export interface BulkMessageEventData {
  sendId: string;
  gymId: string;
  userId: string;
  instanceName: string;
  templateId?: string;
  message: string;
  variableContext?: VariableContextType; // Tipo de contexto
  clients: Array<{
    messageId?: string;
    clientId: string;
    clientName: string;
    phoneNumber: string;
    data: Record<string, any>; // Raw data sin procesar
  }>;
  gymData: Record<string, any>; // Raw data del gym
  contextData?: Record<string, any>; // Data adicional del contexto (activity, event, etc.)
}

export interface SendBulkMessagesEvent {
  name: typeof BULK_MESSAGING_EVENTS.SEND_BULK_MESSAGES;
  data: BulkMessageEventData;
}
